import React from "react";
import "../../resources.css";
import { ResourceRoute } from "../../resource-routing";
import { Button, Collapse, Modal, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import NewsHeadings from "./common-action/news-heading";
import NewsSubscription from "./common-action/subscripbe-section";

class NewsIssue82 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageEnabled: false,
      modalShow: false,
      letftStickyContnet: (
        <div className="news-sticky">
          <div className="left-text">
            ePrescribing <span>webinar</span> By Dr. Maanas Samant
          </div>
          <div className="news-pic">
            <img src="/assets/img/health-img/maanas.png" />
          </div>
        </div>
      ),
    };
  }

  handleClose() {
    this.setState({ modalShow: false });
  }
  handleShow() {
    this.setState({ modalShow: true });
  }

  render() {
    return (
      <div className="newdesigned_issue_details">
        <NewsHeadings
          buttondDetail="HealthTech"
          categoryType="healthtech"
          description="The Role of Machine Learning in Medical Decision-Making"
          newDetail={true}
        />
        {/* <div className='banner-section'>
                    <div className='banner-left'>
                        <img src='/assets/newsletter_images/chart.jpg' alt='chart'/>
                    </div>
                    <div className='banner-right'>
                        <span>Webinar | 26 May 2023</span>
                        <strong>Explore ePrescription in healthcare with Dr. Maanas where he takes us through the evolution, roadblocks and future of eRx.</strong>
                       <a className='read-more' href='https://www.bigmarker.com/ionixx-technologies1/The-Evolution-Impact-and-Opportunities-of-ePrescribing-006672d4a45239798841b834?show_live_page=true' target='_blank'>Watch More</a>
                    </div>
                 </div> */}
        {/*                  
                 <div className='sticky-button banner-modal-button'>
                    <button onClick={() => this.handleShow()}>ePrescription webinar with Dr.Maanas Samant</button>
                 </div> */}
        {/*modal content */}
        <Modal
          className="newsletter-modal theme-change"
          centered
          show={this.state.modalShow}
          onHide={() => this.handleClose()}
        >
          <Modal.Header closeButton>
            <div className="banner-section">
              <div className="banner-left">
                <img src="/assets/newsletter_images/chart.jpg" alt="chart" />
              </div>
              <div className="banner-right">
                <span>Webinar | 26 May 2023</span>
                <p>
                  Explore ePrescription in healthcare with Dr. Maanas where he
                  takes us through the evolution, roadblocks and future of eRx.
                </p>
                <a
                  className="read-more"
                  href="https://www.bigmarker.com/ionixx-technologies1/The-Evolution-Impact-and-Opportunities-of-ePrescribing-006672d4a45239798841b834"
                  target="_blank"
                >
                  Watch Now
                </a>
              </div>
            </div>
          </Modal.Header>
        </Modal>

        <div className="newsissuedetailed">
          <div className="detailed-common">
            {/* <div className="back-to-common">
                            <span className="back-to-icon-hold">
                                <img src="/assets/img/resource/back-to-new.svg" alt="back to new"></img>
                            </span>
                            <Link to={ResourceRoute.NEWSLETTER}><span className="back-to-link">Newsletter</span></Link>
                        </div> */}

            <div className="headlines-warp">
              <div className="top-news">
                <i>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="234"
                    height="140"
                    viewBox="0 0 234 140"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_462_1735)">
                      <path
                        d="M45.2302 29.1322L42.6203 21.6729H0.319092V29.1322V34.9968V130.329H140.56V29.1322H45.2302Z"
                        fill="#00AEEF"
                        stroke="#263238"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M137.93 39.0251H2.94177V124.135H137.93V39.0251Z"
                        fill="white"
                        stroke="#263238"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M112.278 31.947H45.2111V36.0325H112.278V31.947Z"
                        fill="white"
                        stroke="#263238"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M6.1898 31.2925L4.25629 33.1478L6.26 35.289"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.25629 33.1477H8.55086"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17.1528 31.2925L19.0927 33.1478L17.0826 35.289"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M19.0927 33.1477H14.7917"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M28.3263 32.8999C28.1158 32.0612 27.2607 31.3687 26.3545 31.3687C25.2889 31.3687 24.421 32.2328 24.421 33.2939C24.421 34.3549 25.2889 35.2191 26.3545 35.2191C26.8204 35.2191 27.2479 35.0539 27.5797 34.7807"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M27.0245 33.116H28.5305V31.3369"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M38.581 32.487L36.7943 31.0447L35.0969 32.487V35.6131H38.581V32.487Z"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M37.4707 33.332H36.1115V35.505H37.4707V33.332Z"
                        fill="#263238"
                      />
                      <path
                        d="M35.0969 32.4871L34.0759 33.4147"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M38.581 32.4871L39.5382 33.3321"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M37.9365 25.5295L40.6549 28.3252"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M40.6996 25.574L37.8918 28.2807"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M130.822 32.6968H136.201"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M130.822 33.9041H136.201"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M130.822 35.1113H136.201"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M130.822 36.3184H136.201"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M105.622 7.77701L103.012 0.317627H60.7111V7.77701V13.6416V108.974H200.952V7.77701H105.622Z"
                        fill="#00AEEF"
                        stroke="#263238"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M198.329 17.6699H63.3402V102.779H198.329V17.6699Z"
                        fill="white"
                        stroke="#263238"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M172.67 10.5918H105.603V14.6773H172.67V10.5918Z"
                        fill="white"
                        stroke="#263238"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M66.5818 9.93726L64.6483 11.7926L66.6584 13.9338"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M64.6483 11.7925H68.9493"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M77.5512 9.93726L79.4847 11.7926L77.481 13.9338"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M79.4847 11.7925H75.1838"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M88.7248 11.5447C88.5142 10.706 87.6591 10.0134 86.753 10.0134C85.6873 10.0134 84.8195 10.8775 84.8195 11.9386C84.8195 12.9997 85.6873 13.8638 86.753 13.8638C87.2188 13.8638 87.6463 13.6986 87.9782 13.4254"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M87.423 11.7608H88.9226V9.98169"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M98.9731 11.1318L97.1863 9.68945L95.4889 11.1318V14.2642H98.9731V11.1318Z"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M97.8691 11.9768H96.5099V14.1498H97.8691V11.9768Z"
                        fill="#263238"
                      />
                      <path
                        d="M95.4889 11.1318L94.4679 12.0595"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M98.9731 11.1318L99.9366 11.9769"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M98.3285 4.18066L101.047 6.96999"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M101.092 4.21875L98.2902 6.92548"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M191.22 11.3416H196.6"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M191.22 12.5488H196.6"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M191.22 13.7561H196.6"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M191.22 14.9631H196.6"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M138.358 38.485L135.742 31.032H93.4468V38.485V44.3559V139.682H233.681V38.485H138.358Z"
                        fill="#00AEEF"
                        stroke="#263238"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M231.058 48.3779H96.0695V133.487H231.058V48.3779Z"
                        fill="white"
                        stroke="#263238"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M205.406 41.3062H138.339V45.3917H205.406V41.3062Z"
                        fill="white"
                        stroke="#263238"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M99.3176 40.6516L97.3777 42.5069L99.3878 44.6482"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M97.3777 42.5068H101.679"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M110.281 40.6516L112.214 42.5069L110.21 44.6482"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M112.214 42.5068H107.913"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M121.454 42.2591C121.244 41.4204 120.388 40.7278 119.482 40.7278C118.417 40.7278 117.549 41.5919 117.549 42.653C117.549 43.7141 118.417 44.5782 119.482 44.5782C119.948 44.5782 120.376 44.413 120.707 44.1398"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M120.152 42.4751H121.658V40.6897"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M131.702 41.8398L129.922 40.4038L128.218 41.8398V44.9722H131.702V41.8398Z"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M130.598 42.6848H129.239V44.8578H130.598V42.6848Z"
                        fill="#263238"
                      />
                      <path
                        d="M128.218 41.8398L127.197 42.7739"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M131.702 41.8398L132.666 42.6913"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M131.064 34.8887L133.783 37.678"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M133.821 34.9331L131.02 37.6398"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M223.95 42.0559H229.329"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M223.95 43.2632H229.329"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M223.95 44.4705H229.329"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M223.95 45.6775H229.329"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M116.668 91.6094H144.797"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M116.668 95.2246H144.797"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M116.668 98.8401H144.797"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M116.668 102.462H144.797"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M116.668 106.077H144.797"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M116.668 109.692H144.797"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M116.668 113.308H144.797"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M116.668 116.929H144.797"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M116.668 120.545H144.797"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 91.6094H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 95.2246H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 98.8401H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 102.462H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 106.077H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 109.692H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 113.308H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 116.929H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 120.545H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 62.96H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 66.5752H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 70.197H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 73.8123H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 77.4275H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 81.043H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 84.6646H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M149.748 88.28H177.871"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M182.688 91.6094H210.817"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M182.688 95.2246H210.817"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M182.688 98.8401H210.817"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M182.688 102.462H210.817"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M182.688 106.077H210.817"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M182.688 109.692H210.817"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M182.688 113.308H210.817"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M182.688 116.929H210.817"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M182.688 120.545H210.817"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M135.48 68.7228C135.627 68.3098 135.697 67.7825 135.697 67.3949C135.697 65.7492 134.025 65.6539 132.372 65.6539H131.958V65.2664H139.143V65.6539C137.273 65.6539 136.616 66.8358 136.01 68.6021L132.2 79.9818C131.907 80.8269 131.664 81.4559 130.771 81.4559H130.701L127.325 70.5845L124.173 79.9818C123.879 80.8269 123.636 81.4559 122.743 81.4559H122.673L117.772 65.6539H116.049V65.2664H122.36V65.6539H120.567L124.204 78.1201H124.351L127.095 69.8093L125.806 65.6539H124.083V65.2664H130.394V65.6539H128.601L132.238 78.1201H132.385L135.493 68.7228H135.48Z"
                        fill="#00AEEF"
                      />
                      <path
                        d="M211.085 61.6638H182.14V87.7145H211.085V61.6638Z"
                        fill="#00AEEF"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M211.085 72.5479C210.3 72.586 209.349 72.7067 208.194 72.9545C203.798 73.9076 202.649 80.1851 197.678 80.1851C193.275 80.1851 192.898 74.2825 186.587 73.52C184.679 73.2913 183.231 73.6725 182.133 74.3079V87.7017H211.079V72.5415L211.085 72.5479Z"
                        fill="#263238"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M191.756 67.6237C191.756 69.4092 190.301 70.8578 188.508 70.8578C186.715 70.8578 185.26 69.4092 185.26 67.6237C185.26 65.8383 186.715 64.3896 188.508 64.3896C190.301 64.3896 191.756 65.8383 191.756 67.6237Z"
                        fill="white"
                        stroke="#263238"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_462_1735">
                        <rect width="234" height="140" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </i>
                <h4>Top Blog</h4>
                <span>
                  How introducing cutting-edge technologies such as Artificial
                  Intelligence (AI) and Machine Learning (ML) has the potential
                  to amplify the functionalities of ePrescribing systems.
                </span>
                <a
                  href="https://blog.ionixxtech.com/the-evolution-impact-and-opportunities-of-eprescribing/"
                  target="_blank"
                >
                  Read More...
                </a>
              </div>
              <div className="headlines-content">
                <strong className="overall-heading">
                  HealthTech news roundup
                </strong>
                <div className="headlines-list">
                  <a
                    href="https://www.forbes.com/sites/robertpearl/2023/05/15/stuck-in-reverse-how-zigzagging-is-undermining-us-healthcare/?sh=2bcd6b451f90"
                    target="_blank"
                  >
                    How Zigzagging Is Undermining US Healthcare
                  </a>
                  <p>
                    U.S. healthcare is in a financial crisis, and patients feel
                    it acutely. Nearly 90 million Americans are a part of
                    Medicaid, the public health insurance program for low-income
                    groups. Medical bills are a leading cause of bankruptcy, as
                    100 million Americans remain saddled with medical debt.
                  </p>
                </div>
                <div className="headlines-list">
                  <a
                    href="https://www.meddeviceonline.com/doc/ai-driven-medtech-begins-to-deliver-on-its-potential-0001"
                    target="_blank"
                  >
                    AI-Driven Medtech Begins To Deliver On Its Potential
                  </a>
                  <p>
                    Today, healthcare professionals use AI-enabled devices and
                    platforms every day, from performing robot-assisted joint
                    replacements to analyzing X-rays and flagging anomalies for
                    further review by a human radiologist.
                  </p>
                </div>
                <div className="headlines-list">
                  <a
                    href="https://healthtechmagazine.net/article/2023/05/us-military-embraces-telecritical-care-technology-service-members-and-veterans"
                    target="_blank"
                  >
                    U.S. Military Embraces Telecritical Care Technology for
                    Service Members and Veterans
                  </a>
                  <p>
                    The program equips intensive care unit rooms with telehealth
                    technologies, allowing care providers to remotely monitor
                    patients in real-time and provide remote support to onsite
                    medical staff.
                  </p>
                </div>
                <div className="headlines-list">
                  <a
                    href="https://www.healthcareitnews.com/video/how-digitization-and-partnership-can-address-health-inequities"
                    target="_blank"
                  >
                    How Digitization And Partnership Can Address Health
                    Inequities
                  </a>
                  <p>
                    By leveraging the collective power of stakeholders and
                    governments, member states can advance health equity
                    worldwide, says Dr. Hans Kluge, regional director for Europe
                    at the World Health Organization.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="new-detail-option">
          <div className="news-first-section">
            <div className="heading">
              <div className="detail-heading">
                <h5>
                  <span>1</span>Beyond The Hype <br />
                  <em>Defining AI, ML, and DL</em>
                </h5>
              </div>
            </div>
            <div className="newsissuedetailed">
              <p>
                Understanding the foundations of AI and its subfields, Machine
                Learning (ML) and Deep Learning (DL), is crucial for
                appreciating their impact on medical decision-making.{" "}
              </p>
              <p>
                ML involves the development of algorithms that continuously
                improve through experience by learning from data. These ML
                models can get conditioned to recognize patterns, make
                predictions, and adapt their behavior as they process new
                information. In telemedicine, ML algorithms play a crucial role
                in analyzing patient data, medical images, and other pertinent
                information. They assist healthcare providers in diagnosing
                diseases, tailoring treatments to individual patients, and
                closely monitoring patient health.
              </p>
              <p>
                On the other hand, DL represents a more advanced approach. It
                leverages the power of artificial neural networks to model and
                solve problems. These networks are similar to the intricate
                structure and functionality of the human brain. With these
                neural networks, deep learning models can effectively process
                and interpret data hierarchically. DL excels at handling vast
                volumes of data, including unstructured data like images and
                text, which makes it particularly well-suited for tasks such as
                medical image analysis, natural language processing, and
                advanced predictive analytics in the healthcare domain.
              </p>
            </div>
          </div>
          <div className="news-first-section">
            <div className="heading">
              <div className="detail-heading">
                <h5>
                  <span>2</span>Leveraging AI for Stroke Detection:
                  <br /> <em>A Case in Point</em>
                </h5>
              </div>
            </div>
            <div className="newsissuedetailed">
              <div className="news-left">
                <i>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="169"
                    height="169"
                    viewBox="0 0 169 169"
                    fill="none"
                  >
                    <path
                      d="M166.086 81.5861H163.172H132.327L129.413 78.6722L147.038 61.0526C149.926 58.1681 151.517 54.3306 151.517 50.2482C151.517 46.1658 149.926 42.3286 147.038 39.4408C141.077 33.4848 131.38 33.4792 125.418 39.4408L125.292 39.5662L125.167 39.4408C119.208 33.4848 109.508 33.4792 103.547 39.4408C100.659 42.3283 99.068 46.1658 99.068 50.2482C99.068 54.3303 100.659 58.1677 103.547 61.0526L121.172 78.6722L118.258 81.5861H89.8281C88.6247 78.1946 85.3846 75.7586 81.5851 75.7586C77.7856 75.7586 74.5455 78.1946 73.342 81.5861H67.0161C65.5911 81.5861 64.3761 82.6176 64.1431 84.0221L61.41 100.412L52.4181 37.4656C52.2141 36.0406 50.9991 34.9771 49.5566 34.9656C48.0151 34.9045 46.8817 36 46.6575 37.425L39.5975 82.1459C39.108 81.7904 38.5105 81.5865 37.8784 81.5865H28.6396C27.4361 78.1949 24.196 75.7589 20.3965 75.7589C16.597 75.7589 13.3569 78.1949 12.1535 81.5865H5.82753H2.91393H0V87.414H2.91393H5.82786H14.5693C16.1778 87.414 17.4832 86.1115 17.4832 84.5001C17.4832 82.8916 18.7917 81.5861 20.3972 81.5861C22.0027 81.5861 23.3111 82.8916 23.3111 84.5001C23.3111 86.1115 24.6166 87.414 26.225 87.414H35.7795L38.029 94.1624C38.4544 95.4389 39.6869 96.237 41.033 96.1469C42.3705 96.0363 43.4601 95.0223 43.67 93.6964L49.3899 57.4719L58.306 119.877C58.507 121.298 59.7191 122.362 61.1556 122.377C61.1671 122.377 61.179 122.377 61.1905 122.377C62.6125 122.377 63.8305 121.348 64.0635 119.941L69.4861 87.414H75.7595C77.368 87.414 78.6735 86.1115 78.6735 84.5001C78.6735 82.8916 79.9819 81.5861 81.5874 81.5861C83.1929 81.5861 84.5 82.8916 84.5 84.5001C84.5 86.1115 85.8055 87.414 87.4139 87.414H119.466C120.238 87.414 120.981 87.108 121.526 86.5604L125.293 82.7929L129.061 86.5601C129.605 87.108 130.349 87.4137 131.121 87.4137H163.172H166.086H169V81.5861H166.086ZM126.147 73.6986L125.293 74.5522L124.439 73.6986L107.668 56.9326C105.878 55.1465 104.897 52.7716 104.897 50.2485C104.897 47.7221 105.881 45.3475 107.668 43.5615C109.512 41.72 111.933 40.799 114.358 40.799C116.782 40.799 119.203 41.7196 121.045 43.5615L123.23 45.7499C124.323 46.8424 126.26 46.8424 127.353 45.7499L129.538 43.5615C133.227 39.8785 139.23 39.8785 142.919 43.5615C144.708 45.3475 145.69 47.7254 145.69 50.2485C145.69 52.772 144.708 55.1465 142.919 56.9326L126.147 73.6986Z"
                      fill="#F45757"
                    />
                    <path
                      d="M3 25.5H165.5M165.5 167.5V2M125.5 36.5V2M85 167.5V94M3 167.5V2M43 167.5V106.5M42.5 25.5V2M3 143H165.5M85 62.5V2M125.5 167.5V87.5"
                      stroke="#F45757"
                      stroke-width="3"
                      stroke-dasharray="7 7 7 7"
                    />
                  </svg>
                </i>
                {/* <strong></strong> */}
                <b>
                  In addition to these specific examples, AI-driven methods in
                  stroke detection can utilize real-time data from electronic
                  health records (EHRs) and other sources. By integrating with
                  EHR systems, AI algorithms can access a patient's complete
                  medical history, including laboratory results, medications,
                  and previous diagnoses. This comprehensive information allows
                  AI systems to provide more accurate assessments and
                  predictions regarding stroke risk, prognosis, and treatment
                  options.
                </b>
              </div>
              <div className="news-right">
                <p>
                  Stroke detection is where AI-driven methods have shown great
                  promise in healthcare. By utilizing various algorithms and
                  machine learning techniques, AI systems can analyze patient
                  data and assist healthcare professionals in accurately
                  detecting and diagnosing strokes.
                </p>
                <b className="sub-heading">
                  Key tools and frameworks that are significant in stroke
                  detection
                </b>
                <ul className="stroke-list">
                  <li>
                    <span></span>
                    <b>NIHSS (National Institutes of Health Stroke Scale):</b>
                    <p>
                      The NIHSS is a standardized assessment tool used to
                      evaluate the severity of stroke symptoms. This automated
                      approach can save time for clinicians and provide
                      consistent and objective evaluations.
                    </p>
                  </li>
                  <li>
                    <span></span>
                    <b>CHA2DS2-VASc:</b>
                    <p>
                      This scoring system assesses the risk of stroke in
                      patients with atrial fibrillation (a common heart rhythm
                      disorder). AI algorithms can analyze patient data,
                      including medical history, age, sex, and comorbidities,
                      and calculate the CHA2DS2-VASc score. By automating this
                      process, AI can help identify individuals at a higher risk
                      of stroke, enabling healthcare providers to intervene and
                      provide appropriate treatments.
                    </p>
                  </li>
                  <li>
                    <span></span>
                    <b>ABCD2:</b>
                    <p>
                      ABCD2 is a scoring system used to assess the risk of
                      stroke in individuals who have experienced a transient
                      ischemic attack (TIA), often considered a warning sign of
                      an impending stroke. Helping healthcare professionals
                      determine the urgency of follow-up care and interventions.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="news-first-section">
            <div className="heading">
              <div className="detail-heading">
                <h5>
                  <span>3</span>EHR Integration:
                  <br /> <em>Key to Accurate Stroke Detection</em>
                </h5>
              </div>
            </div>
            <div className="newsissuedetailed">
              <div className="news-left">
                <i>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="172"
                    height="157"
                    viewBox="0 0 172 157"
                    fill="none"
                  >
                    <path
                      d="M118.529 84.3942H103.08L96.5964 65.422C95.9098 63.4156 93.7098 62.333 91.6886 63.0162C90.7748 63.3241 90.0108 63.9641 89.5466 64.8158C89.5176 64.8687 89.4934 64.912 89.4693 64.9553L89.4596 64.9697C89.3435 65.1911 89.2565 65.398 89.1888 65.6097L77.9614 101.297L67.6092 42.2589C67.5947 42.1867 67.5802 42.1097 67.556 42.0327C67.5415 41.9798 67.527 41.922 67.5077 41.8691C67.4883 41.8066 67.469 41.744 67.4448 41.6815C67.4206 41.6189 67.3964 41.5564 67.3723 41.4986C67.3481 41.4457 67.3287 41.3976 67.3046 41.3447C67.2756 41.2821 67.2417 41.2196 67.2079 41.157C67.1837 41.1137 67.1547 41.0656 67.1305 41.0223C67.0918 40.9645 67.058 40.9068 67.0193 40.8491C66.9854 40.8009 66.9516 40.7528 66.9178 40.7095C66.8791 40.6614 66.8404 40.6085 66.8017 40.5604C66.7582 40.5074 66.7147 40.4593 66.6712 40.4112C66.6373 40.3727 66.5986 40.3342 66.56 40.2957C66.5068 40.2428 66.4487 40.1899 66.3955 40.1417L66.294 40.0551C66.2312 40.0022 66.1683 39.9541 66.1006 39.906L65.9991 39.8338C65.9314 39.7857 65.8637 39.7424 65.7911 39.7039C65.7476 39.6798 65.7089 39.6558 65.6703 39.6365C65.6074 39.6028 65.5397 39.5692 65.472 39.5355C65.4188 39.5114 65.3656 39.4874 65.3125 39.4681C65.2544 39.4441 65.1964 39.42 65.1384 39.4008C65.0659 39.3767 64.9982 39.3526 64.9305 39.3334L64.7806 39.2901C64.7032 39.2708 64.6307 39.2564 64.5533 39.242C64.4808 39.2275 64.4373 39.2179 64.3938 39.2131C64.3309 39.2035 64.2632 39.1987 64.1955 39.1939C64.1133 39.1842 64.0601 39.1794 64.0021 39.1794C63.9634 39.1794 63.9247 39.1794 63.8861 39.1794C63.7604 39.1794 63.683 39.1794 63.6056 39.1794L63.5186 39.189C63.388 39.2035 63.3058 39.2083 63.2188 39.2227L63.0883 39.2468C63.0061 39.2612 62.9287 39.2805 62.8465 39.2997C62.7933 39.3141 62.7401 39.3286 62.6918 39.3478C62.6289 39.3671 62.5612 39.3863 62.4984 39.4104C62.4355 39.4344 62.3775 39.4585 62.3146 39.4826C62.2614 39.5066 62.2082 39.5259 62.1599 39.5547C62.097 39.5836 62.0342 39.6173 61.9713 39.651C61.9278 39.675 61.8795 39.6991 61.8359 39.728C61.7731 39.7664 61.7151 39.8049 61.6522 39.8434C61.6087 39.8723 61.5652 39.906 61.5216 39.9397C61.4685 39.9782 61.4153 40.0215 61.3621 40.0648C61.3137 40.1033 61.2702 40.1418 61.2267 40.1851C61.1832 40.2235 61.1397 40.2669 61.0961 40.3102C61.0478 40.3583 60.9994 40.4064 60.9559 40.4593C60.9221 40.4978 60.8882 40.5363 60.8544 40.5796C60.806 40.6373 60.7625 40.6951 60.719 40.7528C60.69 40.7961 60.661 40.8346 60.632 40.8779C60.5933 40.9357 60.5546 40.9982 60.5159 41.0608C60.4869 41.1089 60.4627 41.157 60.4337 41.2051C60.4047 41.2629 60.3709 41.3206 60.3467 41.3783C60.3177 41.4409 60.2887 41.5034 60.2645 41.566C60.2451 41.6189 60.221 41.667 60.2065 41.72C60.1774 41.7969 60.1533 41.8739 60.1339 41.9509L60.1146 42.0135L48.7857 84.3942H16.9699L16.8248 84.2403C8.8225 75.358 4.4176 63.5936 4.4176 51.1123C4.4176 48.591 4.60134 46.06 4.96398 43.5965C6.80137 31.0237 13.3724 19.6154 22.9945 12.2921C36.6105 1.90859 54.9506 1.76905 68.6246 11.936C73.7741 15.7661 77.6616 20.6787 79.8617 26.1399C80.0744 26.6788 80.2388 27.1119 80.3839 27.5401C81.2252 29.9459 83.4784 37.5097 85.9879 37.4231C88.5264 37.5049 90.7844 29.9363 91.6354 27.5064C91.7708 27.1119 91.9304 26.6788 92.1383 26.1592C94.3432 20.6835 98.2307 15.7613 103.38 11.9312C117.049 1.76905 135.385 1.90859 149.005 12.2921C158.623 19.6154 165.194 31.0237 167.036 43.5965C167.399 46.06 167.582 48.591 167.582 51.1123C167.582 64.2817 162.491 76.9603 153.613 85.8955L151.404 88.1136C147.574 91.9581 143.633 95.9181 139.838 99.9406L94.2561 148.249C94.1643 148.35 94.0724 148.451 93.9902 148.562C92.0513 151.117 89.2082 152.585 86.191 152.589C86.0362 152.585 85.9057 152.585 85.78 152.589C82.787 152.589 79.9584 151.117 78.0146 148.562C77.9324 148.451 77.8405 148.346 77.7487 148.249L43.0752 111.503"
                      stroke="#F45757"
                      stroke-width="7"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </i>
                <strong>Tackling Alert Fatigue</strong>
                <b>
                  The refined algorithms would strike a balance between
                  sensitivity and specificity, reducing the occurrence of
                  unnecessary alerts while ensuring crucial notifications are
                  promptly conveyed to healthcare professionals.
                </b>
              </div>
              <div className="news-right">
                <p>
                  The integration of AI-driven tools for stroke detection has
                  been a promising development. However, their implementation in
                  clinical settings has encountered a significant obstacle in
                  the form of alert fatigue. This phenomenon occurs when
                  healthcare providers get bombarded with numerous notifications
                  and alerts, a considerable portion of which may be false
                  positives or hold minimal clinical relevance. The consequence
                  is the gradual desensitization and diminished responsiveness
                  of healthcare professionals to genuinely critical
                  notifications.
                </p>
                <p>
                  To tackle this issue, we must refine the algorithms powering
                  these tools, focusing on minimizing false positives and
                  prioritizing alerts based on their clinical significance.
                </p>
              </div>
            </div>
          </div>
          <div className="news-first-section">
            <div className="heading">
              <div className="detail-heading">
                <h5>
                  <span>4</span>Machine Learning for Telemedicine-
                  <br /> <em> A Winning Combination?</em>
                </h5>
              </div>
            </div>
            <div className="newsissuedetailed">
              <div className="news-left">
                <i>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="181"
                    height="234"
                    viewBox="0 0 181 234"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_2_3052)">
                      <mask
                        id="mask0_2_3052"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="181"
                        height="234"
                      >
                        <path d="M181 0H0V233.217H181V0Z" fill="white" />
                      </mask>
                      <g mask="url(#mask0_2_3052)">
                        <path
                          opacity="0.1"
                          d="M166.532 1.13965H9.43903C4.226 1.13965 0 5.36565 0 10.5787V223.096C0 228.309 4.226 232.535 9.43903 232.535H166.532C171.745 232.535 175.971 228.309 175.971 223.096V10.5787C175.971 5.36565 171.745 1.13965 166.532 1.13965Z"
                          fill="#1D2939"
                        />
                        <path
                          opacity="0.1"
                          d="M169.688 1.82129H12.5948C7.38176 1.82129 3.15576 6.04729 3.15576 11.2603V223.778C3.15576 228.991 7.38176 233.217 12.5948 233.217H169.688C174.901 233.217 179.127 228.991 179.127 223.778V11.2603C179.127 6.04729 174.901 1.82129 169.688 1.82129Z"
                          fill="#1D2939"
                        />
                        <path
                          d="M171.559 0H14.4659C9.25285 0 5.02686 4.226 5.02686 9.43903V221.956C5.02686 227.169 9.25285 231.395 14.4659 231.395H171.559C176.772 231.395 180.998 227.169 180.998 221.956V9.43903C180.998 4.226 176.772 0 171.559 0Z"
                          fill="#3E8BFF"
                        />
                        <path
                          d="M171.559 0H14.4659C9.25285 0 5.02686 4.226 5.02686 9.43903V221.956C5.02686 227.169 9.25285 231.395 14.4659 231.395H171.559C176.772 231.395 180.998 227.169 180.998 221.956V9.43903C180.998 4.226 176.772 0 171.559 0Z"
                          fill="#1E4B5E"
                        />
                        <path
                          d="M166.677 14.0176H15.6079V213.229H166.677V14.0176Z"
                          fill="#BAD6FF"
                        />
                        <path
                          d="M168.548 11.9834H17.479V211.195H168.548V11.9834Z"
                          fill="white"
                        />
                        <path
                          d="M66.0696 18.0727V12.5428H119.317V18.0727C119.317 19.5182 118.146 20.6891 116.7 20.6891H68.686C67.2405 20.6891 66.0696 19.5182 66.0696 18.0727ZM63.6043 11.9814V18.3371C63.6043 20.9981 65.7606 23.1545 68.4216 23.1545H116.963C119.624 23.1545 121.78 20.9964 121.78 18.3371V11.9814H63.6025H63.6043Z"
                          fill="#CCCACA"
                        />
                        <path
                          d="M63.9255 0V17.6935C63.9255 20.3545 66.0819 22.5108 68.7429 22.5108H117.284C119.945 22.5108 122.101 20.3545 122.101 17.6935V0H63.9238H63.9255ZM66.3909 17.4308V11.9009H119.638V17.4308C119.638 18.8763 118.467 20.0472 117.021 20.0472H69.0073C67.5618 20.0472 66.3909 18.8763 66.3909 17.4308Z"
                          fill="#0F0F0F"
                        />
                        <path
                          d="M153.366 40.6528H50.3027V40.9687H153.366V40.6528Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M41.8195 40.967H32.0269V31.1743H41.8195V40.967ZM32.3427 40.6511H41.5037V31.4902H32.3427V40.6511Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M153.366 58.2441H50.3027V58.56H153.366V58.2441Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M41.8195 58.5603H32.0269V48.7676H41.8195V58.5603ZM32.3427 58.2444H41.5037V49.0835H32.3427V58.2444Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M153.366 75.8384H50.3027V76.1543H153.366V75.8384Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M41.8195 76.1545H32.0269V66.3618H41.8195V76.1545ZM32.3427 75.8386H41.5037V66.6777H32.3427V75.8386Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M153.366 93.4326H50.3027V93.7485H153.366V93.4326Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M41.8195 93.7468H32.0269V83.9541H41.8195V93.7468ZM32.3427 93.4309H41.5037V84.27H32.3427V93.4309Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M153.366 111.024H50.3027V111.34H153.366V111.024Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M41.8195 111.34H32.0269V101.547H41.8195V111.34ZM32.3427 111.024H41.5037V101.863H32.3427V111.024Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M153.366 128.618H50.3027V128.934H153.366V128.618Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M41.8195 128.932H32.0269V119.14H41.8195V128.932ZM32.3427 128.616H41.5037V119.456H32.3427V128.616Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M152.718 145.761H49.6548V146.077H152.718V145.761Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M41.8195 146.527H32.0269V136.734H41.8195V146.527ZM32.3427 146.211H41.5037V137.05H32.3427V146.211Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M153.366 163.645H50.3027V163.961H153.366V163.645Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M41.8195 163.961H32.0269V154.168H41.8195V163.961ZM32.3427 163.645H41.5037V154.484H32.3427V163.645Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M153.366 181.239H50.3027V181.555H153.366V181.239Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M41.8195 181.552H32.0269V171.76H41.8195V181.552ZM32.3427 181.237H41.5037V172.076H32.3427V181.237Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M153.366 198.644H50.3027V198.959H153.366V198.644Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M41.8195 198.96H32.0269V189.167H41.8195V198.96ZM32.3427 198.644H41.5037V189.483H32.3427V198.644Z"
                          fill="#1F1F1F"
                        />
                        <path
                          d="M35.9863 52.4948L37.3563 55.3876L46.1104 48.7676"
                          stroke="#129981"
                          stroke-width="1.03009"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M35.9863 34.5333L37.3563 37.4245L46.1104 30.8062"
                          stroke="#129981"
                          stroke-width="1.03009"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M35.9863 70.0873L37.3563 72.9801L46.1104 66.3618"
                          stroke="#129981"
                          stroke-width="1.03009"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M35.9863 87.681L37.3563 90.5739L46.1104 83.9556"
                          stroke="#129981"
                          stroke-width="1.03009"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M35.9863 105.275L37.3563 108.166L42.821 104.036"
                          stroke="#129981"
                          stroke-width="1.03009"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="clip0_2_3052">
                        <rect width="181" height="234" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </i>
                <b>
                  ML algorithms can play a pivotal role in achieving this by
                  assisting physicians in developing personalized treatment
                  plans. By analyzing a patient's medical history, genetic
                  factors, and other relevant data, ML algorithms can help
                  identify the most effective treatment options, minimize
                  adverse effects, and optimize patient outcomes.
                </b>
              </div>
              <div className="news-right">
                <p>
                  Telemedicine relies heavily on remote patient monitoring,
                  which is greatly enhanced by ML algorithms.
                </p>
                <p>
                  ML algorithms can analyze data from wearable devices, mobile
                  apps, and other monitoring tools, allowing them to detect
                  changes in patient's health, predict potential complications,
                  and deliver alerts to the appropriate healthcare
                  professionals. This proactive approach, known as preventative
                  care, enables timely interventions, helps prevent
                  complications, and significantly improves overall patient
                  satisfaction.
                </p>
                <p>
                  Real-time decision support powered by ML algorithms allows for
                  appropriate interventions or adjustments to treatment plans
                  based on genetic factors.
                </p>
                <p>
                  The amalgamation of telemedicine, remote patient monitoring,
                  and ML algorithms can reshape healthcare delivery and empower
                  physicians with the tools they need to deliver exceptional
                  care in a rapidly evolving healthcare landscape.
                </p>
              </div>
            </div>
          </div>
          <div className="news-first-section">
            <div className="heading">
              <div className="detail-heading">
                <h5>
                  <span>5</span>The Road Ahead
                </h5>
              </div>
            </div>
            <div className="newsissuedetailed">
              <div className="newissuedetailed_banner">
                <span className="banner-wall">
                  <img src="/assets/newsletter_images/ebook-notepad-clip.png" />
                </span>
                <p>
                  AI's rapid growth has transformed patient care, introducing
                  innovations like remote monitoring and personalized
                  treatments.
                </p>
                <p>
                  With machine learning algorithms set to play a pivotal role in
                  enhancing medical decision-making. However, alongside these
                  exciting developments, we must address the challenges and
                  ethical considerations arising from integrating AI into
                  healthcare. Responsible practices and robust frameworks that
                  uphold patient safety and privacy are essential before fully
                  embracing AI-driven medical decision-making tools.
                </p>
                <p>
                  By navigating these complexities and prioritizing improved
                  patient care and outcomes, we can pave the way for a future
                  where AI revolutionizes healthcare, improves patient outcomes,
                  sets new standards for quality care, and works in favor of
                  both patients and providers.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="final-section newsissuedetailed">
          <strong>
            That’s a wrap
            <br />
            <span>Hope you enjoyed it!</span> <br />
          </strong>
          <div className="checkout-interesting">
            <a href="https://blog.ionixxtech.com/">
              Check out our interesting Blogs
            </a>
          </div>
        </div>
        <div className="events-wrap">
          <strong>Events</strong>
          <div className="events-list">
            <div className="events">
              <img src="/assets/newsletter_images/event-1.png" />
              <p>
                Live from #HIMSS23 in Chicago: Ionixx's CMIO, Dr. Maanas Samant,
                MD, is connecting with healthcare innovators from around the
                world!
              </p>
            </div>
            <div className="events">
              <img src="/assets/newsletter_images/event-2.png" />
              <p>
                Live from #HIMSS23 in Chicago: Ionixx's CMIO, Dr. Maanas Samant,
                MD, is connecting with healthcare innovators from around the
                world!
              </p>
            </div>
          </div>
        </div>
        <NewsSubscription categoryType="HealthTech" />
      </div>
    );
  }
}

export default NewsIssue82;
